import { Modal } from './ui/Modal';
import { Button } from './ui/Button';

export interface ConfirmDialogProps {
    open: boolean;
    title: string;
    message?: string;
    /** Extra call-out rendered in a bright, high-attention color below `message` — for a consequence the user must not miss (e.g. wasted resources on overspill). */
    warning?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export default function ConfirmDialog({
    open,
    title,
    message,
    warning,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    danger = false,
    onConfirm,
    onCancel,
}: ConfirmDialogProps) {
    return (
        <Modal
            open={open}
            onClose={onCancel}
            title={title}
            size="sm"
            // Above TutorialOverlay's z-[60] spotlight backdrop — this dialog
            // is opened from inside the tutorial (e.g. "Disable tutorial?"),
            // so it must render above the backdrop's own pointer-events-auto
            // click-catcher, not behind it.
            zIndexClassName="z-[70]"
            aria-describedby={warning ? 'confirm-dialog-warning' : undefined}
        >
            <div className="flex flex-col gap-4">
                {message && (
                    <p className="text-body text-content-secondary">{message}</p>
                )}
                {warning && (
                    <p
                        id="confirm-dialog-warning"
                        data-testid="confirm-dialog-warning"
                        className="text-body font-bold text-status-warning"
                    >
                        {warning}
                    </p>
                )}
                <div className="flex gap-3 justify-end mt-2">
                    <Button
                        type="button"
                        variant="secondary"
                        size="sm"
                        onClick={onCancel}
                    >
                        {cancelLabel}
                    </Button>
                    <Button
                        type="button"
                        variant={danger ? 'danger' : 'primary'}
                        size="sm"
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
